import {applyMiddleware, createStore, Store} from 'redux';
import thunk from 'redux-thunk';
import {logger} from 'redux-logger';
import {rootReducer, RootState} from './reducers';
import {Build} from '@stencil/core';
import {store as reduxStore} from '@stencil/redux';

const middlewares = [thunk];
if (Build.isDev) {
    middlewares.push(logger);
}

export const initialStore: Store<RootState> = createStore(rootReducer, applyMiddleware(...middlewares));
reduxStore.setStore(initialStore);
export const store = reduxStore;

